/**
 * SkinErrorBoundary — ловит ошибки загрузки/рендера 3D-превью скина.
 *
 * Зачем: useGLTF бросает промис в Suspense, и если GLTFLoader не смог
 * разобрать ответ (сервер отдал HTML вместо glb, 404, обрыв сети), ошибка
 * всплывает вверх по дереву React. Без границы она сносит ВЕСЬ кабинет:
 * Canvas отмонтируется, WebGL теряет контекст
 * («THREE.WebGLRenderer: Context Lost») и пользователь видит тёмный экран
 * вместо страницы — ровно то, что случилось 2026-07-09 и 2026-07-31.
 *
 * С границей падает только превью — меню, каталог и остальной кабинет
 * продолжают работать.
 */
import React from "react";

export default class SkinErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    // Не спамим Sentry-подобной телеметрией — достаточно консоли,
    // чтобы причина оставалась видна при разборе жалоб.
    console.error("Не удалось загрузить 3D-превью скина:", error);
  }

  componentDidUpdate(prevProps) {
    // Сменили скин — даём превью ещё один шанс: битым мог быть
    // конкретный файл, а не рендер вообще.
    if (this.state.failed && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ failed: false });
    }
  }

  render() {
    if (this.state.failed) {
      return (
        this.props.fallback || (
          <div
            style={{
              width: "100%",
              height: "100%",
              minHeight: 220,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              padding: 16,
              color: "#aaa",
              fontSize: 13,
              lineHeight: 1.5,
            }}
          >
            Не удалось загрузить 3D-модель.
            <br />
            Попробуй обновить страницу или выбрать другого персонажа.
          </div>
        )
      );
    }
    return this.props.children;
  }
}
